import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService, ButtonLoader } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';
import { ClienteAnaliseFinanceiraHttpService, ClienteAnaliseFinanceiraRevisarHttpService } from '../services';
import { ClienteAnaliseFinanceiraFormComponent } from '../form';
import { ClienteNomePipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-financeira-revisar-modal',
    templateUrl: './cliente-analise-financeira-revisar-modal.component.html',
    styleUrls: ['./cliente-analise-financeira-revisar-modal.component.less'],
    providers: [
        ClienteNomePipe
    ]
})
export class ClienteAnaliseFinanceiraRevisarModalComponent implements OnInit {
    idCliente: number;
    cliente: ClienteAnaliseFinanceira;
    elModal: any;
    isLoading: boolean;

    @ViewChild('form') form: ClienteAnaliseFinanceiraFormComponent;
    @ViewChild('btnRevisar') btnRevisar: ElementRef;

    @Output() afterRevisar = new EventEmitter<ClienteAnaliseFinanceira>();

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteNomePipe: ClienteNomePipe,
                private clienteAnaliseFinanceiraHttpService: ClienteAnaliseFinanceiraHttpService,
                private clienteAnaliseFinanceiraRevisarHttpService: ClienteAnaliseFinanceiraRevisarHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.load()
                    .then(() => {
                        setTimeout(() => this.form?.setFocusAnotacao(), 200);
                    })
                    .catch(() => {});

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Carrega a análise financeira do cliente */
    private load(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.cliente = null;
            this.isLoading = true;
            this.clienteAnaliseFinanceiraHttpService.load(this.idCliente)
                .pipe(
                    take(1)
                )
                .subscribe(
                    cliente => {
                        this.cliente = cliente;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        this.close();
                        reject();
                    },
                    () => this.isLoading = false
                );
        });
    }

    private clear() {
        this.idCliente = null;
        this.cliente = null;
    }

    open(idCliente: number) {
        this.idCliente = idCliente;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Revisa a análise financeira do cliente */
    revisar() {
        if (!this.form.isValid()) {
            return;
        }

        const btn = new ButtonLoader(this.btnRevisar.nativeElement);
        btn.loading('Revisando');
        this.clienteAnaliseFinanceiraRevisarHttpService.revisar(this.cliente)
            .pipe(
                take(1)
            )
            .subscribe(
                cliente => {
                    this.afterRevisar.emit(cliente);
                    this.messageService.success('', `Revisão da Análise Financeira do cliente ${this.clienteNomePipe.transform(cliente?.nome, cliente?.nomeFantasia, cliente?.codigoIntegracaoErp)} realizada com sucesso`);
                    this.close();
                },
                (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                () => btn.reset()
            );
    }
}
